import PropTypes from 'prop-types';
import useSelectCancellationReasson from './useSelectCancellationReasson';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';

const SelectCancellationReasson = ({ value, onChange }) => {
  const { getData, isLoading, cancellationReassons } = useSelectCancellationReasson();

  const getOptionData = (option) => {
    return {
      label: option.name,
      value: option._id,
    };
  };

  const onSelectValue = (option) => {
    const selectedOption = cancellationReassons.find((reason) => reason._id === option.value);
    onChange(selectedOption);
  };

  return (
    <>
      <DropdownSelect
        isLoading={isLoading}
        onChange={onSelectValue}
        options={cancellationReassons}
        value={value}
        onSearch={getData}
        getOptionData={getOptionData}
      />
    </>
  );
};

export default SelectCancellationReasson;
SelectCancellationReasson.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};
